// onboardingBusinessUpdated definition
export default function (businessId) {
  return this.sendEvent('onboarding.businessUpdated', { businessId })
}
